var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"is-info margin-bottom-10",on:{"click":_vm.getReportData}},[_vm._v(" Show Invoice Journal Report's Current State ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }